import { Component, OnInit} from '@angular/core';

import { ToasterService } from 'angular2-toaster';
import { AlertService } from './services/index';
import { Router, NavigationEnd } from '@angular/router'

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<toaster-container></toaster-container><router-outlet></router-outlet>'
})
export class AppComponent { 
  constructor(
    private alertService: AlertService, 
    private toasterService: ToasterService,
    private router: Router){
    
  }
 
  ngOnInit() {
    this.alertService.getMessage().subscribe(message => { 
        if(message){
            this.toasterService.pop(message.type, message.title, message.text);
        }
    });

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
          return;
      }
      window.scrollTo(0, 0)
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts